const renderHotel = (map, marker, infowindow, id) => {
  $.ajax({
    url: '/maps/get_hotel_content?id=' + id.toString(),
    success: (hotel_data) => {
      infowindow.setContent(hotel_data);
      infowindow.open(map, marker);
    }
  });
}

class GlobalMap {
  constructor(map_wrapper, map_data, center_map, map_zoom) {
    this.map_wrapper = map_wrapper;
    this.map_data = map_data;
    this.center_map = center_map;
    this.map_zoom = map_zoom;
    this.renderMap();
  }

  renderMap() {
    const fenway = new google.maps.LatLng(this.center_map.lat, this.center_map.lng);
    const mapOptions = {
      center: fenway,
      scrollwheel: true,
      zoom: this.map_zoom,
      width: '100%'
    };
    const map = new google.maps.Map(document.getElementById(this.map_wrapper), mapOptions);

    $.ajax({
      url: '/maps/get_markers',
      success: (map_data) => {
        const infowindow = new google.maps.InfoWindow();
        for (var data of map_data) {
          let coords = new google.maps.LatLng(data.lat, data.lng);
          let marker = new google.maps.Marker({
            position: coords,
            map: map,
            animation: google.maps.Animation.DROP,
            title: data.name,
          });

          let hotel = data.id;
          let content = data.content;
          try {
            infowindow.close();
          } catch(err) {};

          google.maps.event.addListener(marker, 'click', (function(marker, content, hotel, infowindow) {
            return function() {
              renderHotel(map, marker, infowindow, hotel);
            };
          })(marker, content, hotel, infowindow));

          google.maps.event.addListener(map, 'click', () => {
            infowindow.close()
          });
        }
      }
    });
  }
}

window.GlobalMap = GlobalMap;